import JSSHA from "jssha/src/sha1";
import md5 from "js-md5";
import { getToken } from "@/api/microService";
import Storage from "@/utils/storage";
const common = {
  CloudToken() {
    let appid = process.env.Cloud_Appid;
    let secret_key = process.env.Cloud_SecretKey;
    let shortid = process.env.Cloud_Shortid;
    let duration = process.env.Cloud_Duration;
    let expiredTime = parseInt(Date.now() / 1000, 10) + duration;
    let rawMask = `${appid}_${expiredTime}_${secret_key}`;
    const shaObj = new JSSHA("SHA-1", "TEXT");
    shaObj.setHMACKey(secret_key, "TEXT");
    shaObj.update(rawMask);
    const hexMask = shaObj.getHMAC("HEX");
    const token = [shortid, expiredTime, hexMask].join(":");
    return token;
  },
  MicroToken() {
    var micro_token;
    micro_token = Storage.localGet("micro_token");
    let merId = process.env.Micro_MerId;
    let secretKey = process.env.Micro_SecretKey;
    let busiCode = process.env.Micro_BusiCode;
    let sign = md5(
      secretKey + 'busiCode"' + busiCode + '"merId"' + merId + '"' + secretKey
    ).toUpperCase();
    let data = { merId: merId, busiCode: busiCode, sign: sign };
    return new Promise((resolve, reject) => {
      getToken(JSON.stringify(data))
        .then(response => {
          response = response.data;
          if (response.resCode === "000000") {
            micro_token = response.resData.token;
            Storage.localSet("micro_token", micro_token);
            resolve(response);
          }
        })
        .catch(function(error) {
          reject(error);
          // console.log(error);
        });
    });
  }
};

export default common;



// WEBPACK FOOTER //
// ./src/utils/common.js